import { WrenchTheme } from '@wds/styles';
import { merge } from 'lodash';

const changes = {
	palette: {
		name: 'Accessible',
		primary: {
			main: '#007500',
			contrast: '#FFFFFF',
			hover: '#00AD65',
		},
		muted: {
			main: '#373535',
			contrast: '#ffffff',
		},
	},
};

export const DefaultAccessibleTheme = merge({}, WrenchTheme, changes);
